import type { Theme } from "@mui/material/styles";

export type CenterModalSize = "sm" | "md" | "lg";

const SIZE_TOKENS: Record<
  CenterModalSize,
  { defaultMdWidth: number; titleFontSize: { xs: string; md: string } }
> = {
  sm: {
    defaultMdWidth: 400,
    titleFontSize: { xs: "1.125rem", md: "1.25rem" },
  },
  md: {
    defaultMdWidth: 480,
    titleFontSize: { xs: "1.5rem", md: "2rem" },
  },
  lg: {
    defaultMdWidth: 600,
    titleFontSize: { xs: "1.5rem", md: "2.125rem" },
  },
};

export function getCenterModalSizeTokens(size: CenterModalSize) {
  return SIZE_TOKENS[size];
}

export function resolveCenterModalWidth(
  width: number | { xs?: number | string; md?: number | string } | undefined,
  size: CenterModalSize,
): { width: string; maxWidth: number | string } {
  const { defaultMdWidth } = getCenterModalSizeTokens(size);
  const maxWidth =
    typeof width === "number" ? width : (width?.md ?? defaultMdWidth);
  return {
    width: "calc(100% - 2 * var(--Margin-Padding-M))",
    maxWidth,
  };
}

/** Default header / content padding (rem). Modals may override via `headerSx` / `contentSx`. */
export function centerModalHeaderBaseSx(_theme: Theme) {
  return {
    px: { xs: "1.25rem", md: "1.5rem" },
    pt: "2rem",
    pb: "1rem",
  } as const;
}

export function centerModalContentBaseSx(_theme: Theme) {
  return {
    px: { xs: "1.25rem", md: "1.5rem" },
    pt: 0,
    pb: 0,
  } as const;
}
